/** @format */

import { request } from '@power/runtime-vue3';

export function getsysColumns(params) {
	return request({
		url: '/base/system/sysColumns/query',
		method: 'get',
		params,
	});
}

export function saveSysColumns(data) {
	return request(
		{
			url: '/base/system/sysColumns/saveOrUpdate',
			method: 'post',
			data,
		},
		{
			isGetDataDirectly: false,
		},
	);
}
